/**
 * Page images live in a top-level `images` map — not inside section copy.
 *
 *   images.hero      hero / PageHero
 *   images.card      thumbnail on hub and home grids
 *   images.section1  first content section
 *   images.section2  second content section
 *
 * Example: change the second section on /card-readers/stripe-m2
 *   content/cardReaders.js → slug stripe-m2 → images.section2
 */

export function heroImageOf(page) {
  return page?.images?.hero || page?.heroImage || ''
}

export function cardImageOf(page) {
  return page?.images?.card || page?.cardImage || heroImageOf(page)
}

export function sectionImageOf(page, index) {
  const key = `section${index + 1}`
  return page?.images?.[key] || page?.sections?.[index]?.image || ''
}

export function sectionsWithImages(page) {
  return (page?.sections || []).map((section, index) => ({
    ...section,
    image: sectionImageOf(page, index),
  }))
}
